import React from "react";
import Header from "./header";
import Posts from "./posts";

const Feed = () => {
  return (
    <div className="feed">
      <Header />
      <Posts />
    </div>
  );
};

export default Feed;
